import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.25",
  height: "19.873"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8383",
  d: "m13.625 2.822 9.994 17.667a1.105 1.105 0 0 1-.994 1.638H2.637a1.105 1.105 0 0 1-.994-1.638l9.994-17.667a1.153 1.153 0 0 1 1.988 0zm-.994 1.471L3.44 20.537h18.382zm-.586 14.546a1.479 1.479 0 0 0 .586.107 1.505 1.505 0 0 0 1.089-2.584 1.535 1.535 0 0 0-1.089-.429 1.5 1.5 0 0 0-1.081 2.576 1.479 1.479 0 0 0 .495.33zM11.47 7.815l.159 6.925h2.035l.191-6.925z",
  transform: "translate(-1.506 -2.254)",
  style: {"fill":"#f16755","fill-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };